import { Button } from "antd";
import DehazeIcon from "@material-ui/icons/Dehaze";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { useBilling } from "../Kitchen/billingProvider";
import { useEffect, useState } from "react";
import { InputAdornment, TextField } from "@material-ui/core";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import dayjs from "dayjs";
import { Button as BSButton } from "react-bootstrap";
import { useDebounce } from "../../hooks/useDebounce";
import ItemNotFound from "./ItemNotFoundModal";

const formatResult = (item) => {
  return (
    <div
      style={{
        padding: "1rem 0.75rem",
        borderBottom: "1px solid gray",
      }}
      key={item.value}
      role="listitem"
    >
      <div className="result-span">
        {item.name}
        {item.color && (
          <span
            style={{
              height: "20px",
              width: "20px",
              borderRadius: "50%",
              backgroundColor: item.color,
              display: "inline-block",
              marginLeft: "0.5rem",
              marginRight: "0.5rem",
              verticalAlign: "middle",
            }}
          />
        )}
        {item.size && <span> (Size - {item.size})</span>}
      </div>
    </div>
  );
};

const BillingTopBar = () => {
  const navigate = useNavigate();
  const [productCode, setProductCode] = useState("");
  const debouncedSearchEanCode = useDebounce(productCode, 200);
  const productsForSearch = useSelector((state) => state.productsForSearch);
  const { productList: products } = useSelector((state) => state.products);
  const shopType = useSelector((state) => state.shopDetails.shopType);
  const [itemNotFoundModal, setItemNotFoundModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { addProductToBilling } = useBilling();

  const clearSearch = () => {
    const inputElement = document.querySelector(".clear-icon");
    inputElement.click();
  };

  const handleOnSelect = (item) => {
    const getProduct = products.find((i) => {
      return item.id === i.productId;
    });
    addProductToBilling({ ...getProduct, count: 1, isExist: true });
    setTimeout(() => {
      clearSearch();
    }, 100);
  };
  const handleQrCodeChange = (e) => {
    const value = e.target.value;
    setProductCode(value);
  };
  useEffect(() => {
    if (debouncedSearchEanCode) {
      const getProduct = products.find((i) => {
        return (
          i.productEANCode?.toLowerCase() ===
          debouncedSearchEanCode?.toLowerCase()
        );
      });
      if (getProduct) {
        addProductToBilling({ ...getProduct, count: 1, isExist: true });
        setSearchTerm("");
        setProductCode("");
      } else {
        setItemNotFoundModal(true);
      }
    }
  }, [debouncedSearchEanCode]);
  return (
    <div className="invoice-generator-head">
      <div className="invoice-generator-head-btn1">
        <BSButton
          variant="text"
          onClick={() => navigate("/dashboard/overview")}
        >
          <DehazeIcon style={{ marginTop: -5 }} />
        </BSButton>
      </div>
      <div
        style={{ marginTop: 10, marginBottom: 10, display: "flex" }}
        className="invoice-generator-head-btn2"
      >
        <div
          className="invoice-generator-head-textfield"
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ReactSearchAutocomplete
            items={productsForSearch}
            onSelect={handleOnSelect}
            styling={{
              borderRadius: 4,
              boxShadow: "none",
              zIndex: 100,
            }}
            inputSearchString={searchTerm}
            formatResult={formatResult}
            placeholder="Search items by typing product name or code"
            showIcon={true}
            showClear={true}
            maxResults={10}
            fuseOptions={{
              shouldSort: true,
              threshold: 0.6,
              location: 0,
              distance: 75,
              minMatchCharLength: 1,
              keys: ["name", "productCode"],
              includeMatches: false,
            }}
          />
        </div>

        <TextField
          id="scanItem"
          className="invoice-generator-head-textfield"
          placeholder="Place your cursor here and start scanning the product"
          value={productCode}
          //onBlur={() => setProductArray([])}
          onChange={handleQrCodeChange}
          style={{ marginLeft: 10 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <QrCodeScannerIcon />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </div>
      <div className="invoice-generator-head-title" style={{ marginTop: 10 }}>
        <h4
          style={{
            marginRight: 20,
          }}
        >
          {dayjs().format("DD, MMMM YYYY")}{" "}
        </h4>
      </div>
      <ItemNotFound
        open={itemNotFoundModal}
        onClose={() => setItemNotFoundModal(false)}
        productCode={productCode}
        onCloseAddProduct={() => {
          document.querySelector("#billingAddItem").click();
        }}
      />
    </div>
  );
};

export default BillingTopBar;
